export default __webpack_public_path__ + "static/media/handset.dd7a68ad.png";